<template>
    <div class="grid grid-cols-12 gap-1">
        <div class="col-span-12 md:col-span-6">
            <FormControl
                :required="required"
                :label="localizer.translate(TextTokenEnum.BookingForm_Country)"
            >
                <PhoneCountryCodeSelector
                    :value="localSelectedPhoneCountryCode ?? '1'"
                    :name="phoneCountryCodeFieldName"
                    :useBookingFormThemeCssVariables="true"
                    :required="required"
                    :disabled="disabled"
                    @onPhoneCountryCodeSelectionChange="
                        (event) => (localSelectedPhoneCountryCode = event.value)
                    "
                />
            </FormControl>
        </div>
        <div class="col-span-12 md:col-span-6">
            <FormControl
                :required="required"
                :label="
                    localizer.translate(
                        TextTokenEnum.BookingForm_PhoneOnlyNumbers,
                    )
                "
            >
                <TextInput
                    :useBookingFormThemeCssVariables="true"
                    inputmode="numeric"
                    pattern="[0-9]{4,20}"
                    :name="phoneNumberFieldName"
                    :value="selectedPhoneNumber"
                    :required="required"
                    :disabled="disabled"
                />
            </FormControl>
        </div>
        <div class="col-span-12">
            <slot name="bottomContent" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import PhoneCountryCodeSelector from '@/BookingForm/BookingForm/Component/PhoneCountryCodeSelector.vue'
    import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import type LocalizerService from '@/Shared/Service/Localization/LocalizerService'

    const props = defineProps({
        phoneNumberFieldName: {
            type: String,
            required: true,
        },
        phoneCountryCodeFieldName: {
            type: String,
            required: true,
        },
        localizer: {
            type: Object as () => LocalizerService,
            required: true,
        },
        selectedPhoneNumber: {
            type: [String, null],
            required: true,
        },
        selectedPhoneCountryCode: {
            type: [String, null],
            required: true,
        },
        required: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })

    const localSelectedPhoneCountryCode = ref<string>(
        props.selectedPhoneCountryCode ?? '1',
    )
</script>
